<ng-container *transloco="let t">
  <div>
    <nz-page-header class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title class="text-primary flex items-center gap-2">
        {{ t('experiences.title') }}
        <nz-icon
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipArrowPointAtCenter]="true"
          [nzTooltipTitle]="'nav.featureTooltips.experiences' | transloco"
          [nzTooltipOverlayStyle]="{
            'max-width': '400px',
            'min-width': '300px',
            'white-space': 'normal',
            'line-height': '1.5'
          }"
          nzType="info-circle"
          nzTheme="outline">
        </nz-icon>
      </nz-page-header-title>
      <nz-page-header-extra>
        <nz-space class="flex flex-col-reverse md:flex-row">
          <div class="pe-3 mt-2 md:mt-0">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
              <input
                type="text"
                nz-input
                [placeholder]="t('experiences.searchPlaceholder')"
                (keydown.enter)="this.search()"
                [(ngModel)]="searchName" />
            </nz-input-group>
            <ng-template #inputClearTpl>
              <span
                *ngIf="searchName"
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                (click)="reset()">
              </span>
            </ng-template>
            <ng-template #suffixButton>
              <button
                nz-button
                nzType="primary"
                (click)="search()"
                nzSearch>
                {{ t('experiences.searchBtn') }}
              </button>
            </ng-template>
          </div>
          <div>
            <button
              *appHasAnyPrivilege="'EXPERIENCE.ADD'"
              nz-button
              nzType="primary"
              [routerLink]="'/admin/content/experiences/add'"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="file-pen" class="icon-size"></lucide-icon>
              {{ t('experiences.addBtn') }}
            </button>
          </div>
        </nz-space>
      </nz-page-header-extra>
    </nz-page-header>
  </div>

  <div class="my-4">
    <div class="flex justify-end items-center mx-5 my-2 gap-4">
      <div class="flex items-center gap-2" *ngIf="authService.isSuperAdmin()">
        <nz-select
          [(ngModel)]="selectedCreator"
          [nzPlaceHolder]="t('experiences.filterByCreator')"
          nzAllowClear
          style="width: 200px;"
          (ngModelChange)="onCreatorChange()">
          <nz-option
            *ngFor="let creator of creators"
            [nzValue]="creator._id"
            [nzLabel]="creator.name">
          </nz-option>
        </nz-select>
      </div>
    </div>
    <nz-table
      #basicTable
      [nzData]="listOfData"
      #ZonesTable
      [nzShowSizeChanger]="pageSize.length > 5"
      [nzPageSizeOptions]="pageSize.pageSizeOptions"
      [nzLoading]="isLoading"
      [nzBordered]="true"
      [nzPageSize]="pageSize.pageSize"
      [nzPageIndex]="pageSize.pageIndex"
      [nzFrontPagination]="false"
      [nzTotal]="pageSize.length"
      (nzQueryParams)="onTableParamsChange($event)"
      [nzScroll]="{ x: '1100px' }">
      <thead>
        <tr>
          <th nzWidth="150px">{{ t('experiences.table.name') }}</th>
          <th nzWidth="60px" [nzSortFn]="sortColumn.compare">
            {{ t('experiences.table.createdDate') }}
          </th>
          <th nzWidth="80px" [nzSortFn]="sortColumn.compareUpdated">
            {{ t('experiences.table.updatedDate') }}
          </th>
          <th nzWidth="80px">{{ t('experiences.table.createdBy') }}</th>
          <th nzWidth="80px" *appHasAnyPrivilege="'EXPERIENCE.EDIT,EXPERIENCE.DELETE'">
            {{ t('experiences.table.action') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.area ? data.name + ', ' + data.area : data.name }}</td>
          <td>{{ data.createdAt | date }}</td>
          <td>{{ data?.updatedAt ? (data.updatedAt | date) : '-' }}</td>
          <td>{{ data?.creator|| '-' }}</td>
          <td *appHasAnyPrivilege="'EXPERIENCE.EDIT,EXPERIENCE.DELETE'">
            <div class="flex items-center gap-5">
              <button
                *appHasAnyPrivilege="'EXPERIENCE.EDIT'"
                nz-button
                nzType="default"
                nzSize="small"
                [routerLink]="'/admin/content/experiences/edit/' + data._id"
                class="flex items-center justify-center gap-2">
                <lucide-icon name="pencil" class="icon-size"></lucide-icon>
                {{ t('experiences.editBtn') }}
              </button>
              <button
                *appHasAnyPrivilege="'EXPERIENCE.DELETE'"
                nz-button
                nzType="default"
                nzSize="small"
                nzDanger
                (click)="showArchiveModal(data._id, data.name)"
                class="flex items-center justify-center gap-2">
                <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
